import {DEFAULT_SETTINGS} from '../../constants/defaultSettings';
import {FeGridSettings} from '../../types/Api';
import {selectGridSettings} from '../createEagGridStore';
import {useEagGridSelector} from '../useEagGridSelector';

export function useGridSettingsSafe(): FeGridSettings {
  const settings = useEagGridSelector(selectGridSettings);
  return settings ?? DEFAULT_SETTINGS;
}
